import Banner from 'components/Banner/Banner'
import { SectionTitle } from 'components/Sections/SectionTitle'
import SectionWrapper from 'components/Wrapper/SectionWrapper'
import { imgUrls } from 'constants/imgUrls'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import OurTeam from './Sections/OurTeam'

const AboutUs = () => {

    return (
        <>
            <Banner imgUrl={imgUrls.aboutUsBanner} />
            <SectionWrapper>
                <SectionTitle title="ABOUT US"></SectionTitle>
                <Container>
                    <Row>
                        <Col>
                            content
                        </Col>
                    </Row>
                </Container>
                <OurTeam />
            </SectionWrapper>
        </>
    )
}

export default AboutUs;